import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';
import { PageData } from '../types';

interface TopPagesWidgetProps {
  timePeriod?: string;
  pages: PageData[];
}

const TopPagesWidget: React.FC<TopPagesWidgetProps> = ({ 
  timePeriod = '7d',
  pages
}) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 px-0">
        <CardTitle className="text-sm font-medium">Top Pages</CardTitle>
        <FileText className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="px-0">
        <div className="space-y-2">
          {pages.map((page, index) => (
            <div key={page.name} className="group relative px-0">
              <div className="relative flex items-center justify-between p-2 rounded-lg overflow-hidden">
                {/* Background Progress Bar */}
                <div 
                  className="absolute inset-0 bg-primary/10 transition-all duration-300 ease-out"
                  style={{ width: `${page.percentage}%` }}
                ></div>
                
                {/* Content on top of progress bar */}
                <div className="relative flex items-center space-x-3 flex-1">
                  <div className="flex flex-row relative">
                    <span className="text-sm text-muted-foreground opacity-100 group-hover:opacity-30 transition-opacity duration-200">
                      {page.name.length > 25 
                        ? `${page.name.substring(0, 15)}...${page.name.substring(page.name.length - 7)}`
                        : page.name
                      }
                    </span>
                  </div>
                </div>
              </div>
              <div className="absolute text-right top-0  opacity-0 group-hover:opacity-100 right-0 h-full w-full text-muted-foreground bg-background/30 duration-200 rounded px-2 py-1">
                 <span className="text-xs  transition-opacity px-2 py-1 ">
                   {page.views.toLocaleString()} views
                 </span>
                 <span className="text-sm font-semibold text-foreground">
                   {page.percentage.toFixed(1)}%
                 </span>
               </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default TopPagesWidget;
